import { Button } from 'sm-react-components';
import { withStyles } from '@material-ui/core/styles';
import ArrowBack from '@material-ui/icons/ArrowBack';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

const styles = {
    container: {
        height: '40px',
        boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
        marginBottom: '2px',
        backgroundColor: 'white'
    }
};

class Back extends Component {
    state = { back: false }

    componentWillReceiveProps = (props) => {
        this.setState({ back: false });
    }

    onClick = () => {
        this.setState({ back: true });
    }

    render() {
        const { back } = this.state;
        const { classes, to } = this.props;
        return (
            <div className={classes.container}>
                {back && <Redirect push to={to} />}
                <Button variant='text' color='secondary' onClick={this.onClick}>
                    <ArrowBack className={classes.center} />
                    Back
                </Button>

            </div>
        );
    }
}

export default withStyles(styles)(Back);